import React from 'react';
import Cookies from 'js-cookie';
import { getApplicationUrl } from '@/const/serviceEnv';

export default function FleAi() {
  return (
    <iframe
      style={{ width: '100%', height: '100%', border: 0, background: '#fff' }}
      src={`${getApplicationUrl('fleAI')}/?form=${window.btoa(Cookies.get('token') || '')}&systemId=100005`}
    />
  );
}
